@if (!hide()) {
  <a [class]="'command-bar-image text-center command-bar-button d-lg-block ml-3 ' + formatClass()"
    (click)="buttonClick()" [class.d-none]="hideOnMobile()"
    [class.disabled]="!enabled()" [ngStyle]="calculateSeparators()">
    @if (badgeCount > 0) {
      <span class="counter-badge">{{badgeCount}}</span>
    }
    <div>
      @for (icon of iconClasses(); track icon) {
        <i [class]="icon + ' fa-2x'"></i>
      }
    </div>
    <div>{{text()}}</div>
  </a>
}